import { createFileRoute } from '@tanstack/react-router';

import { EmailArchiveView } from 'src/sections/admin/email-archive/email-archive-view';

export const Route = createFileRoute('/admin-skidog/email-archive/')({
  component: EmailArchivePage,
});

function EmailArchivePage() {
  return <EmailArchiveView />;
}
